import { useEffect, useState, useMemo } from "react";
import { makeStyles, Typography } from "@material-ui/core";

import { api } from "../../../../services/api";
import { capitalize, requestDateFormat } from "../../../../services/utils";
import { ShaDowBox } from "../../../../components/boxes/ShadowBox";
import { PieChart } from "../../../../components/charts/PieChart";
import { PieLegends } from "../../../../components/charts/PieLegends";
import { NoDataCard } from "../../../../components/parts";
import { SAVE_THE_PLANET_COLORS } from "../../constants";
import { GRAPH_UNITS } from "../../../dashboard/constants";
import { onlyUniqueValuesOfKeyInArray } from "../../../../services"

const useStyles = makeStyles((theme) => ({
  box: {
    padding: `${theme.spacing(3)}px ${theme.spacing(3.5)}px`,
  },
}));

export const CarbonReductionTotal = ({ period, startDate, endDate }) => {
  const classes = useStyles();
  const [data, setData] = useState([]);

  const title = "Carbon Emission Reduction - Total";

  useEffect(() => {
    const getCarbonReductionTotal = (url) => {
      api.get(url).then((resp) => {
        if (!onlyUniqueValuesOfKeyInArray(resp.data.results, 'value', 0)) {
          const data = resp.data.results.map((item) => ({
            name: capitalize(item.name),
            value: item.value,
            legendValue: item.value,
            displayValue: item.value,
            displayValueFormat: "tCO2",
            key: item.name,
          }));
          setData(data);
        }
      });
    };

    const getUrl = (period) => {
      let url =
        "/praas/v1/emission-impact/save-the-planet/carbon-reduction-total/";
      if (period.name === "RANGE" && endDate) {
        url += `?from_date=${requestDateFormat(
          startDate
        )}&to_date=${requestDateFormat(endDate)}`;
        getCarbonReductionTotal(url);
      } else if (["YTD", "Acc.", "20Y"].includes(period.name)) {
        url += `?date_filter=${period.filter}`;
        getCarbonReductionTotal(url);
      }
    };

    getUrl(period);
  }, [period, startDate, endDate]);

  const getData = useMemo(() => {
    return data.filter((val) => val.value);
  }, [data]);

  return (
    <ShaDowBox style={{ width: "100%" }}>
      {data.length ? (
        <div className={classes.box} id="carbon-reduction-total">
          <Typography variant="h4">{title}</Typography>
          <PieChart
            data={getData}
            colors={SAVE_THE_PLANET_COLORS}
            name="SaveThePlanet"
          />
          <PieLegends
            data={data}
            colors={SAVE_THE_PLANET_COLORS}
            unit={GRAPH_UNITS.tonCarbon}
          />
        </div>
      ) : <NoDataCard title={title} type="pie" />}
    </ShaDowBox>
  );
};
